<template lang="pug">
    v-list-item.layersSelectItem.rounded-lg.mb-2.mx-4(flat two-lines dense @click="toggleItem" :disabled="selectedTheme.addOverlay")
        v-list-item-content
            v-list-item-title {{item.title[$i18n.locale]}}
            v-list-item-subtitle {{item.description[$i18n.locale]}}
        v-list-item-action
            v-btn(icon @click="toggleItem" :color="selected ? 'accent' : 'grey'")
                v-icon {{selected ? 'check_circle' : 'add_circle_outline'}}

</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["item", "selected"],
  methods: {
    toggleItem() {
      this.$emit("toggleItem", this.item);
    },
  },
  computed: {
    ...mapState({
      selectedTheme: (state) => state.create.selectedTheme,
    }),
  },
};
</script>
<style lang="sass" scoped>
@import '@/assets/style/variables'
.layersSelectItem
    background: $white
    border-radius: $radius
</style>
